import { Scanning } from "../apiRoutes/routes";
import api from "@/interceptors";
import { TYPE_SCHEDULE } from "@/utils/constants";
import dayjs from "dayjs";

export const getScansSummary = (scanType: string) =>
  api.get(Scanning.getScansSummary.replace(":scanType", scanType), {
    params: {
      recentDate: dayjs().format("YYYY-MM-DD"),
      reportingPeriodType: "m",
      periodCount: 12,
    },
  } as any);

export const getScanHistoryWebServices = (ids?: Array<number>) =>
  api.get(
    `${Scanning.getScanHistoryWebServices}${
      ids ? `?webserviceIds=${ids}` : ""
    }`,
  );

export const getScanHistoryDomains = () =>
  api.get(Scanning.getScanHistoryDomains);

export const getScanReportWebServiceCSV = (runId: string | number) =>
  api.get(`${Scanning.getScanReportWebServiceCSV}${runId}`);

export const getScanReportDiffWebService = (
  runId: string | number,
  diffRunId: string | number,
) =>
  api.get(`${Scanning.getScanReportDiffWebService}${runId}`, {
    params: {
      diffRunId: diffRunId,
    },
  });

export const getScanReportDomain = (runId: string | number) =>
  api.get(`${Scanning.getScanReportDomain}${runId}`);
export const getScanReportDomainCSV = (runId: string | number) =>
  api.get(`${Scanning.getScanReportDomainCSV}${runId}`);

export const getScanReportRunWebService = (runId: string | number) =>
  api.get(Scanning.getScanReportRunWebService, {
    params: { runId },
  });

export const postScanReportRunWebService = (runId: string | number) =>
  api.post(Scanning.postScanReportRunWebService, {
    webServiceIds: Array.isArray(runId) ? runId : [runId],
    forceRefresh: true,
    forceNewRuns: true,
  });

export const getScanReportRunDomain = (runId: string | number) =>
  api.get(Scanning.getScanReportRunDomain, {
    params: { runId },
  });

export const postScanReportRunDomain = (runId: any) =>
  api.post(Scanning.postScanReportRunDomain, {
    domainIds: Array.isArray(runId) ? runId : [runId],
    forceRefresh: true,
  });

export const getRefreshIssuesWebServiceScanning = (webserviceIds) => {
  return api.get(
    Scanning.getRefreshIssuesWebServiceScanning.replace(
      ":webserviceId",
      webserviceIds,
    ),
  );
};

export const getRefreshIssuesDomainScanning = (domainIds) => {
  return api.get(
    Scanning.getRefreshIssuesDomainScanning.replace(":domainId", domainIds),
  );
};
export const getScanReportScheduleWebService = () =>
  api.get(`${Scanning.getScanReportScheduleWebServices}`);

export const getScanReportScheduleDomain = () =>
  api.get(`${Scanning.getScanReportScheduleDomains}`);

export const postScanReportSchedule = (
  scanTargetType: keyof typeof TYPE_SCHEDULE,
  data: {
    targetId?: number;
    rrule: string;
    isArchived?: boolean;
    scheduleId?: number | string;
  }[],
  isEdit?: boolean,
  isDelete?: boolean,
) => {
  const apiHost =
    scanTargetType === TYPE_SCHEDULE.domains
      ? Scanning.postScanReportScheduleDomains
      : Scanning.postScanReportScheduleWebServices;

  const dataFormat = data.map((item) => {
    if (isEdit || isDelete) {
      delete item.targetId;
      return item;
    } else {
      delete item.scheduleId;
      return item;
    }
  });

  if (isEdit) {
    return api.put(apiHost, {
      scanTargetType,
      scheduleUpdates: dataFormat,
    });
  }
  if (isDelete) {
    return api.delete(apiHost, {
      data: {
        scanTargetType,
        scheduleDeletes: dataFormat,
      },
    });
  }
  return api.post(apiHost, {
    scanTargetType,
    scheduleInserts: dataFormat,
  });
};

export const getIgnoreScanReportItem = (ignoreItemIds?: string[]) => {
  const params = ignoreItemIds?.length ? { ignoreItemIds } : {};
  return api.get(Scanning.getIgnoreScanReportItem, { params });
};

export const postIgnoreScanReportItem = (data: any) =>
  api.post(Scanning.postIgnoreScanReportItem, data);

export const deleteIgnoreScanReportItem = (payload: {
  ignoreItemIds?: string[];
  data: any;
}) => {
  const { ignoreItemIds, data } = payload;
  const params = ignoreItemIds?.length ? { ignoreItemIds } : {};
  return api.delete(Scanning.deleteIgnoreScanReportItem, {
    params,
    data,
  });
};
